import { render, staticRenderFns } from "./PuiTextArea2.vue?vue&type=template&id=762a7aa8"
import script from "./PuiTextArea2.vue?vue&type=script&lang=js"
export * from "./PuiTextArea2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports